import { default as formFinderLogic } from './FormFinder/logic';
import { default as organizationsLogic } from './SelectOrganization/logic';
import { default as pagePanelLogic } from './PagePanels/logic';
import { default as siteInfoLogic } from './SiteInfo/logic';

export default [...formFinderLogic, ...organizationsLogic, ...pagePanelLogic, ...siteInfoLogic];
